// src/pages/SubmitTimesheet.jsx
import TimesheetForm from '../components/Timesheetform';

export default function SubmitTimesheet() {
  return (
    <div className="p-8">
      <TimesheetForm />
    </div>
  );
}
